/**
 * roadmapData.js — SAFE LOCAL FALLBACK for /roadmap.
 *
 * IMPORTANT: This file is NOT the production source of truth for
 * the public roadmap. The live `/api/integrations/ecosystem/roadmap`
 * is. This module only exposes a SAFE corporate scaffold so the page
 * never renders blank if the live feed is unreachable.
 *
 * Fallback rules (owner directive 2026-02-02):
 *   - SAFE PUBLIC CORPORATE CONTENT ONLY.
 *   - No fake product details, no fake customer counts.
 *   - No internal roadmap items.
 *   - No customer-base figures beyond the gated "Across Japan" label.
 *   - No banned wording (Financial Services / payment services /
 *     remittance / FSA-regulated / bank-grade).
 *
 * Shape is the JTR UI-kit shape (preserved 1-for-1 so the adapter
 * + the kit's SVG/mobile timeline + the modal cycling all "just work"
 * even when running on fallback data).
 */

import { ROADMAP_FROZEN_HASHES } from "./roadmapFrozen";

export const ROADMAP_VERSION = "1.0.0-fallback";
export const LAUNCH_DATE = "2026-12-31";
export const LAUNCH_LABEL_EN = "NoJo Enterprise — Year of Service";
export const LAUNCH_LABEL_JA = "NoJo Enterprise・通年サービス運営";

export const STATUS_META = {
  completed: { en: "Completed", ja: "完了", color: "emerald", dot: "#10b981" },
  in_testing: { en: "In Testing", ja: "検証中", color: "sky", dot: "#0ea5e9" },
  in_progress: { en: "In Progress", ja: "実装中", color: "fuchsia", dot: "#d946ef" },
  planned: { en: "Planned", ja: "予定", color: "amber", dot: "#f59e0b" },
  launch: { en: "Launch", ja: "ローンチ", color: "rose", dot: "#e11d48" },
};

export const CATEGORY_META = {
  "nojo-enterprise": {
    en: "NoJo Enterprise",
    ja: "NoJo Enterprise",
    color: "indigo",
  },
  japanetccard: {
    en: "JapanETCcard.com",
    ja: "JapanETCcard.com",
    color: "violet",
  },
  japantollreceipts: {
    en: "JapanTollReceipts.jp",
    ja: "JapanTollReceipts.jp",
    color: "emerald",
  },
  japanchangemoney: {
    en: "JapanChangeMoney.com",
    ja: "JapanChangeMoney.com",
    color: "sky",
  },
};

export const QUARTERS = [
  {
    key: "q1_2026",
    label: { en: "Q1 2026 · Corporate Site", ja: "2026年第1四半期・コーポレートサイト" },
  },
  {
    key: "q2_2026",
    label: { en: "Q2 2026 · Ecosystem", ja: "2026年第2四半期・エコシステム" },
  },
];

// Single safe corporate milestone — the production timeline is fed
// by the live API, this is purely a "page never blanks" backstop.
export const MILESTONES = [
  {
    id: "nojo-corporate-site-phase-2",
    reviewed: null,
    quarter: "q1_2026",
    status: "completed",
    category: "nojo-enterprise",
    title: {
      en: "Phase 2 public corporate site live",
      ja: "公式コーポレートサイト フェーズ2 公開",
    },
    desc: {
      en: "The NoJo Enterprise public corporate site moved out of the placeholder shell into the full bilingual phase 2 experience.",
      ja: "NoJo Enterpriseの公式コーポレートサイトを、準備中シェルから日本語・英語に対応したフェーズ2へ移行しました。",
    },
  },
];

export { ROADMAP_FROZEN_HASHES };
